document.addEventListener('DOMContentLoaded', function() {
  if (BOLD && BOLD.common && BOLD.common.eventEmitter) {
    BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_changed', function(event) {
      var checkboxes = document.querySelectorAll('.bold_option_value_element input[type="checkbox"].swm_2081124_807355');
      var textElements = document.querySelectorAll('.bold_option_swatch label');

      checkboxes.forEach(function(checkbox, index) {
        checkbox.addEventListener('change', function() {
          var checkedCheckboxes = document.querySelectorAll('.bold_option_value_element input[type="checkbox"].swm_2081124_807355:checked');
          
          if (checkedCheckboxes.length > 3) {
            this.checked = false; // Prevent checking more than 3 checkboxes
          }

          checkboxes.forEach(function(checkbox, i) {
            var isDisabled = checkedCheckboxes.length >= 3 && !checkbox.checked;

            // Disable/enable checkboxes based on the condition
            checkbox.disabled = isDisabled;
            
            // Change color of corresponding text elements based on disabled state
            textElements[i].classList.toggle('disabled-text', isDisabled);

          });
        });
      });
    });

    BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_changed', function(event) {
      var checkboxes = document.querySelectorAll('.bold_option_value_element input[type="checkbox"].cbm_2093917_807355');
      var textElements = document.querySelectorAll('.bold_option_checkboxmulti label');

      checkboxes.forEach(function(checkbox, index) {
        checkbox.addEventListener('change', function() {
          var checkedCheckboxes = document.querySelectorAll('.bold_option_value_element input[type="checkbox"].cbm_2093917_807355:checked');
          
          if (checkedCheckboxes.length > 3) {
            this.checked = false; // Prevent checking more than 3 checkboxes
          }

          checkboxes.forEach(function(checkbox, i) {
            var isDisabled = checkedCheckboxes.length >= 3 && !checkbox.checked;

            // Disable/enable checkboxes based on the condition
            checkbox.disabled = isDisabled;
            
            // Change color of corresponding text elements based on disabled state
            textElements[i].classList.toggle('disabled-text', isDisabled);

          });
        });
      });
    });
  } else {
    console.error('BOLD.common.eventEmitter is not defined');
  }
});
